/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsApplicationIdQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AppSecopsApplicationIdQueryOperator");
    }

    getFixupPrototypeFunction() { return AppSecopsApplicationIdQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsApplicationIdQueryOperator>): AppSecopsApplicationIdQueryOperator {
        let obj = Object.assign(new AppSecopsApplicationIdQueryOperator(), model);
        AppSecopsApplicationIdQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsApplicationIdQueryOperator>): AppSecopsApplicationIdQueryOperator {
        if (!model) return null;
        return AppSecopsApplicationIdQueryOperator.newInstance(<AppSecopsApplicationIdQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsApplicationIdQueryOperator) {
        if (!obj) return;

        models.AppSecopsApplicationIdQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsApplicationIdQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsApplicationIdQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Application IDs to include
     */
    application_ids: Array<string>;

}
